import { Controller } from "@hotwired/stimulus"

// Flips a boolean by PATCHing a toggle route and rendering the turbo stream it
// answers with.
//
// Deliberately not a <form> around the switch: the switches that use this sit
// inside another form, and an HTML parser drops a nested <form> start tag while
// its end tag closes the outer form early — the switch would be dead on load and
// only start working after the first turbo re-render.
//
// The route flips the flag itself, so there is no body to post; the checkbox is
// reverted when the request fails.
export default class extends Controller {
  static values = { url: String }

  async change(event) {
    const input = event.target
    input.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']")?.content,
          Accept: "text/vnd.turbo-stream.html",
        },
      })

      if (!response.ok) throw new Error(`Toggle failed with ${response.status}`)

      Turbo.renderStreamMessage(await response.text())
    } catch (error) {
      console.error("Error toggling:", error)
      input.checked = !input.checked
      input.disabled = false
    }
  }
}
